document.addEventListener("DOMContentLoaded", () => {
  // swiper init
  if (window.innerWidth < 750) {
    const elements = document.querySelectorAll(".text-with-icons__blocks");
    elements.forEach((element) => {
      new Flickity(element, {
        adaptiveHeight: true,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
      });
    });
  }
});
